import * as API from './';
import { WeatherParam } from '@/interfaces/weather_interface';
import { ProjectGroup } from '@/interfaces/api_interface';
import { AxiosRequestConfig } from 'axios';

/**
 * responseMessage
 */
export interface responseMessage<T> {
    /**
     * links
     */
    links: object;
    /**
     * count
     */
    count: number;
    /**
     * current
     */
    current: number;
    /**
     * results
     */
    results: T;
}

/**
 * EquipmentInformation
 */
export interface EquipmentInformation {
    /**
     * id
     */
    id: number;
    /**
     * manufacturer
     */
    manufacturer: string;
    /**
     * kind
     */
    kind: string;
    /**
     * equipType
     */
    equipType: string;
    /**
     * ratedParam
     */
    ratedParam: Record<string, number | string>;
    /**
     * operationalConstraints
     */
    operationalConstraints: Record<string, number | string>;
    /**
     * economicParameters
     */
    economicParameters: {
        PurchaseCost: string;
        FixedOMCost: string;
        VariableOMCost: string;
    };
    /**
     * isDelete
     */
    isDelete: boolean;
    /**
     * simu
     */
    simu: number;
}

/**
 *获取路径中的参数
 */
export function getQueryString(): Record<string, string> {
    const qs = location.search.substring(1); // 获取url中"?"符后的字串
    const args: Record<string, string> = {}; // 保存参数数据的对象
    const items = qs.length ? qs.split('&') : []; // 取得每一个参数项,
    const len = items.length;

    for (let i = 0; i < len; i++) {
        const item = items[i].split('=');
        const name = decodeURIComponent(item[0]),
            value = decodeURIComponent(item[1]);
        if (name) {
            args[name] = value;
        }
    }
    return args;
}

/**
 *把数字转为字符串
 */
export function transformNumberToString(data: object): void {
    if (data == null) {
        return;
    }
    for (const key in data) {
        if (key === 'simu' || key === 'id') {
            continue;
        }
        if (typeof data[key] === 'number') {
            data[key] = String(data[key]);
        } else if (typeof data[key] === 'object') {
            transformNumberToString(data[key]);
        }
    }
}

export default {
    deleteProjectGroup: async (id: number): Promise<Record<string, unknown>> => {
        return await API.DELETE('/rest/projectgroup/' + id + '/');
    },
    getProjectGroup: async (params: Record<string, string>): Promise<{ results: ProjectGroup[] }> => {
        return await API.GET('/rest/projectgroup/', params);
    },
    postProjectGroup: async (params: Record<string, unknown>, config?: AxiosRequestConfig): Promise<Record<string, string>> => {
        return await API.POST('/rest/projectgroup/', params, config);
    },
    putProjectGroup: async (params: Record<string, unknown>, config?: AxiosRequestConfig): Promise<Record<string, string>> => {
        return await API.PUT(`/rest/projectgroup/${params.id}/`, params, config);
    },
    deleteSimuData: async (id: number): Promise<Record<string, unknown>> => {
        return await API.DELETE('/rest/simu/' + id + '/');
    },
    postSimuData: async (params: Record<string, unknown>, config?: Record<string, string>): Promise<Record<string, string>> => {
        return await API.POST<Record<string, string>>('/rest/simu/', params, config);
    },
    //eslint-disable-next-line
    getSimuData: (params: Record<string, unknown>): Promise<any> => {
        const p = params;
        if (p.id) {
            return API.GET('/rest/simu/' + p.id + '/').catch((e) => {
                throw e;
            });
        } else {
            return API.GET('/rest/simu/', params);
        }
    },
    //eslint-disable-next-line
    putSimuData: (params: { id: number }): any => {
        return API.PUT('/rest/simu/' + params.id + '/', params);
    },
    //eslint-disable-next-line
    getOperationStrategy: (params: object): any => {
        return API.GET('/rest/operation_strategy/', params);
    },
    //eslint-disable-next-line
    deleteOperationStrategy: (params: { id: number }): any => {
        return API.DELETE('/rest/operation_strategy/' + params.id + '/', {});
    },
    /** 获取天气 */
    postWeatherParam: (params: { lat: number; lng: number; simu_id: number; id?: number; simu?: number }): Promise<unknown> => {
        return API.POST('/rest/weather_param/', params, {});
    },
    putWeatherParam: (params: { lat: number; lng: number; simu_id: number; id?: number; simu?: number }): unknown => {
        return API.PUT('/rest/weather_param/' + params.id + '/', params);
    },
    getWeatherParam: (params: object): Promise<{ results: Array<{ id: number; lat: string; lng: string; simu: number }> }> => {
        return API.GET('/rest/weather_param/', params);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getWeatherData: (params: { time_after?: string; time_before?: string; sid: string; size?: number; mode?: string }): Promise<{ results: any }> => {
        return API.GET(`/rest/weather_data/`, params);
    },
    postWeatherData: (params: object, header: object): unknown => {
        return API.POST('/rest/weather_data/', params, header);
    },

    updateWeatherData: (params: { id: number }): unknown => {
        return API.PUT('/rest/weather_data/' + params.id + '/', params);
    },
    // 加载天气数据
    loadWeaterData: (params: WeatherParam): Promise<unknown> => {
        return API.GET<unknown>('/load_weather/', params);
    },
    // 加载日期数据
    loadDateData: (params: { simu_id: number }): Promise<{ firstTime: string; lastTime: string }> => {
        return API.GET<unknown>('/load_date/', params) as Promise<{ firstTime: string; lastTime: string }>;
    },
    /**
     * 方案评估模块下的rest方法
     */
    getProjectcalculation: (params: object): unknown => {
        return API.GET('/rest/projectcalculation/', params);
    },
    // 带参数信息库接口
    getDataByParams: (params: { type: string; params: string; search?: string }): Promise<responseMessage<unknown[]>> => {
        if (params.search) {
            return API.GET<responseMessage<unknown[]>>(`/rest/${params.type}/`, {
                simu_id: getQueryString()['simu_id'],
                kind: params.params,
                search: params.search,
            });
        } else return API.GET<responseMessage<unknown[]>>(`/rest/${params.type}/`, { simu_id: getQueryString()['simu_id'], kind: params.params });
    },

    // 方案评估模块get 统一方法
    getDataBySearchValue: (params: { type: string; params: string }): Promise<Record<string, unknown>> => {
        return API.GET('/rest/search/', { type: params.type, value: params.params });
    },
    getEvaluationDataByParams: (params: { type: string; id: number }): Promise<responseMessage<unknown[]>> => {
        return API.GET<responseMessage<unknown[]>>(`/rest/${params.type}/`, { simu_id: getQueryString()['simu_id'], planId: params.id });
    },

    // 方案评估模块put 统一方法
    postEvaluationDataByParams: (params: Record<string, string | number>): unknown => {
        return API.POST(`/rest/${params.type}/`, { ...params, type: undefined }, {});
    },

    // 方案评估模块put 统一方法
    patchEvaluationDataByParams: (params: Record<string, string | number>): unknown => {
        return API.PUT(`/rest/${params.type}/` + params.id + '/', params);
    },
    //投资批次以及比例
    postInvestmentBatchAndProportion: (data: Array<{ planId: number; rate: string; simu: string; year: string }>): Promise<unknown> => {
        return API.POST('/rest/investmentbanchandproportion/', data, {});
    },
    getInvestmentBatchAndProportion: (param: {
        simu_id: number;
        planId: number;
    }): Promise<{ results: Array<{ id: number; year: string; rate: string; simu: number; planId: number }> }> => {
        return API.GET('/rest/investmentbanchandproportion/', param);
    },
    //建设投资明细
    getConstruction: (param: Record<string, string | number>): Promise<unknown> => {
        return API.GET('/taskmanager/getConstruction/', param);
    },
    postConstruction: (data: object): Promise<unknown> => {
        return API.POST('/rest/detailsconstructioninvestment/', data, {});
    },

    getTaskManagerData: (params: { type: string; params?: string; id: number; time?: number }): Promise<responseMessage<unknown[]>> => {
        return API.GET<responseMessage<unknown[]>>(`/taskmanager/${params.type}`, {
            simu_id: getQueryString()['simu_id'],
            planId: params.id,
            time: params.time ? params.time : 0,
        });
    },
    /**
     * 数据管理模块下的数据删除方式
     */
    deleteResource: (params: { type: string; id: number }): Promise<unknown> => {
        return API.DELETE(`/rest/${params.type}/${params.id}/`, {});
    },
    patchDataByType: (id: number, params: object, type: string): Promise<unknown> => {
        transformNumberToString(params);
        return API.PATCH(`/rest/${type}/${id}/`, params);
    },

    postDataByType: (
        type: string,
        params: Array<Record<string, unknown>>,
        header: Record<string, string>,
        config: Record<string, unknown>,
    ): Promise<unknown> => {
        transformNumberToString(params);
        return API.POST(`/rest/${type}/`, params, config);
    },
    getTypicalCase: (params: { type: string }): Promise<unknown[]> => {
        return API.GET('/get_typical_case/', params);
    },
};
